import React, { useMemo } from 'react'
import useTranslation from 'next-translate/useTranslation'
import { HistoryLoads } from './HistoryLoads'
import { HistorySingle } from './HistorySingle'
import { HistoryTrucks } from './HistoryTrucks'

const DetailHistory = ({ transaction, preview, shouldShowCommentsOnly }) => {
  const { t } = useTranslation()
  const isLoadVisible = useMemo(() => transaction?.loadVisible, [transaction])
  const isTruckVisible = useMemo(() => transaction?.truckVisible, [transaction])
  const isBothVisible = useMemo(() => isLoadVisible && isTruckVisible, [isLoadVisible, isTruckVisible])

  return (
    isBothVisible
      ? (
        <div className="d-flex w-100">
          {isLoadVisible && (
            <div className="w-50 col-50 pr-10">
              <div className="tennders-table-zebra text-12 lh-1-3">
                {preview && (
                  <div>
                    <span>{t('transactionHistory:load_updates')}</span>
                  </div>
                )}
                <div>
                  <HistoryLoads id={transaction?.matchedLoad?.id} shouldShowCommentsOnly={shouldShowCommentsOnly} />
                </div>
              </div>
            </div>
          )}
          {isTruckVisible && (
            <div className="w-50 col-50 pl-10">
              <div className="tennders-table-zebra text-12 lh-1-3">
                {preview && (
                  <div>
                    <span>{t('transactionHistory:truck_updates')}</span>
                  </div>
                )}
                <div>
                  <HistoryTrucks id={transaction?.matchedTruck?.id} shouldShowCommentsOnly={shouldShowCommentsOnly} />
                </div>
              </div>
            </div>
          )}
        </div>
      )
      : (
        <HistorySingle>
          {isLoadVisible
            ? (
              <HistoryLoads
                id={transaction?.matchedLoad?.id}
                isSingleView
                shouldShowCommentsOnly={shouldShowCommentsOnly}
              />
            )
            : (
              <HistoryTrucks
                id={transaction?.matchedTruck?.id}
                isSingleView
                shouldShowCommentsOnly={shouldShowCommentsOnly}
              />
            )}
        </HistorySingle>
      )
  )
}

export default DetailHistory
